import AppShell from "@/components/AppShell";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Users, Package, Handshake, Wallet, Upload, Trophy, Gift, Store, Settings, Ticket } from "lucide-react";
import UsersTab from "@/pages/admin/UsersTab";
import ServicesTab from "@/pages/admin/ServicesTab";
import ReferralsTab from "@/pages/admin/ReferralsTab";
import RedemptionsTab from "@/pages/admin/RedemptionsTab";
import VouchersTab from "@/pages/admin/VouchersTab";
import ImportTab from "@/pages/admin/ImportTab";
import Leaderboard from "@/pages/admin/Leaderboard";
import TierUpgrades from "@/pages/admin/TierUpgrades";
import ShopsTab from "@/pages/admin/ShopsTab";
import SettingsTab from "@/pages/admin/SettingsTab";
import ChangePasswordDialog from "@/pages/admin/ChangePasswordDialog";
import SetupStatsCard from "@/pages/admin/SetupStatsCard";

const TABS = [
  { v: "users", i: Users, l: "Users" },
  { v: "services", i: Package, l: "Services" },
  { v: "referrals", i: Handshake, l: "Referrals" },
  { v: "redemptions", i: Wallet, l: "Redemptions" },
  { v: "vouchers", i: Ticket, l: "Vouchers" },
  { v: "shops", i: Store, l: "Shops" },
  { v: "leaderboard", i: Trophy, l: "Leaderboard" },
  { v: "tier-upgrades", i: Gift, l: "Tier Upgrades" },
  { v: "settings", i: Settings, l: "Settings" },
  { v: "import", i: Upload, l: "Import" },
];

export default function AdminDashboard() {
  return (
    <AppShell
      title="Admin console"
      subtitle="Manage users, services, close referrals, and process redemptions."
      right={<ChangePasswordDialog />}
    >
      <SetupStatsCard />
      <Tabs defaultValue="referrals" className="w-full">
        <TabsList className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-10 bg-[#170929] border border-white/10 p-1 rounded-lg h-auto gap-1">
          {TABS.map((t) => {
            const Icon = t.i;
            return (
              <TabsTrigger key={t.v} value={t.v} data-testid={`tab-${t.v}`} className="data-[state=active]:bg-pink-500 data-[state=active]:text-black rounded-md text-slate-300 py-2.5 text-xs sm:text-sm">
                <Icon className="w-4 h-4 mr-1.5 sm:mr-2" strokeWidth={1.5} /> <span className="hidden xs:inline sm:inline">{t.l}</span>
              </TabsTrigger>
            );
          })}
        </TabsList>
        <TabsContent value="users" className="mt-6"><UsersTab /></TabsContent>
        <TabsContent value="services" className="mt-6"><ServicesTab /></TabsContent>
        <TabsContent value="referrals" className="mt-6"><ReferralsTab /></TabsContent>
        <TabsContent value="redemptions" className="mt-6"><RedemptionsTab /></TabsContent>
        <TabsContent value="vouchers" className="mt-6"><VouchersTab /></TabsContent>
        <TabsContent value="shops" className="mt-6"><ShopsTab /></TabsContent>
        <TabsContent value="leaderboard" className="mt-6"><Leaderboard /></TabsContent>
        <TabsContent value="tier-upgrades" className="mt-6"><TierUpgrades /></TabsContent>
        <TabsContent value="settings" className="mt-6"><SettingsTab /></TabsContent>
        <TabsContent value="import" className="mt-6"><ImportTab /></TabsContent>
      </Tabs>
    </AppShell>
  );
}
